module.exports = __webpack_public_path__ + "img/casino.ccdfa7af.svg";